import { render, staticRenderFns } from "./browser-dialog.vue?vue&type=template&id=45dd98e9&"
import script from "./browser-dialog.vue?vue&type=script&lang=js&"
export * from "./browser-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports